import loader from '../utils/loader'
import LayoutMain from '../components/Layout'

const MAIN_ROUTE_NAME = LayoutMain.name

let pathMap = {}

/**
 * 使用模块加载器将src/views下所有子目录中index.vue的页面, 将index.vue所在的父子目录作为key
 * @type {*|根据callback中定义的数据格式返回对象}
 */
export const routeMap = loader.getByCustom(require.context('@/views', true, /index\.vue/), (routeMap, component, path) => {
  let levels = path.split('/')
  levels.shift()
  levels.pop()

  let levelLen = levels.length
  let lastName = levels[levelLen - 1]
  let indexResults = /^\d+/.exec(lastName)
  let routeIndex = -1 >>> 1

  if (indexResults) {
    routeIndex = Number(indexResults[0])
  }

  levels = levels.map(level => level.replace(/^\d+/, ''))

  let routeName = component.name
  let routeInfo = component.routeInfo

  routeMap[routeName] = {
    name: routeName,
    path: routeInfo.path || `/${levels.join('/').toLowerCase()}`,
    component,
    parent: null,
    parentPath: levels.slice(0, levelLen - 1).join('/'),
    routeIndex,
    meta: {
      label: routeInfo.label,
      icon: routeInfo.icon,
      isNav: routeInfo.isNav !== false,
      curdInfo: routeInfo.curdInfo
    }
  }

  pathMap[levels.join('/')] = component.name
})

Object.values(routeMap).forEach(route => {
  let parentName = pathMap[route.parentPath]

  if (parentName) {
    route.parent = parentName
  }
})

pathMap = null

/**
 * 根据moduleId列表, 过滤index.vue模块, 并创建树形结构的路由配置
 * @param moduleIds
 * @returns {{path: string, component: *, children: *, meta: {parent: null}, name: *}}
 */
export const getRouteByModuleIds = moduleIds => {
  let cloneRouteMap = {}

  for (let routeName in routeMap) {
    cloneRouteMap[routeName] = {...routeMap[routeName]}
  }

  let routes = moduleIds.reduce((routes, routeName) => {
    let route = cloneRouteMap[routeName]

    if (route) {
      routes.push(route)
    }

    return routes
  }, [])

  let root = []

  for (let i = 0; i < routes.length; i++) {
    let route = routes[i]
    let parentName = route.parent

    if (parentName) {
      let parent = cloneRouteMap[parentName]

      if (parent) {
        let children = parent.children

        if (!children) {
          children = parent.children = []
          routes.push(parent)
        }

        if (children.indexOf(route) === -1) {
          children.push(route)
        }
      }
    } else if (root.indexOf(route) === -1) {
      root.push(route)
    }
  }

  return {
    name: MAIN_ROUTE_NAME,
    path: '/',
    component: LayoutMain,
    meta: {
      parent: null
    },
    children: root
  }
}



// WEBPACK FOOTER //
// ./src/router/routes.js